import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose Check material spend against each location's contract budget
 * @primary Per-location budget cards
 * @persona procurement, falk-ceo, paola-admin-belora
 */
export const Route = createFileRoute(
  "/app/c/$customerSlug/reporting/materials-budget/",
)({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
